import { Linkedin, MailIcon } from 'lucide-react';

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border">
      <div className="mx-auto flex max-w-5xl flex-col items-center justify-between gap-4 px-6 py-10 text-sm text-muted-foreground sm:flex-row">
        <p className="font-serif text-base text-foreground">Brian Machimbira</p>
        <p>&copy; {year} · Built with care.</p>
        <div className="flex items-center gap-4">
          <a
            href="https://www.linkedin.com/in/brianmachimbira/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="transition-colors hover:text-foreground"
          >
            <Linkedin className="h-5 w-5" />
          </a>
          <a
            href="mailto:brian@brianmachimbira.dev"
            aria-label="Email"
            className="transition-colors hover:text-foreground"
          >
            <MailIcon className="h-5 w-5" />
          </a>
        </div>
      </div>
    </footer>
  );
}
